import { EntityService } from '../EntityService';

export class SendEmailService extends EntityService {

  static entity = 'app/send-email';

  static invoice(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/invoice`, data).then(res => res.data);
  }

  static viewBeforeSend(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/view-before-send`, data).then(res => res.data);
  }

  static payment(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/notification-payment `, data).then(res => res.data);
  }
}
